import React, {PureComponent} from 'react';

import { Classes, Overlay, Collapse, Button, MenuItem } from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import { getJwt } from '../../services/authService';
import http from '../../services/httpService';
import toastr from "toastr";

import InputRegular from '../common/InputRegular';

export default class UpdateCardDateModal extends PureComponent{
    state={
        overlayIsOpen: false,
        year: '',
        month: '',
        fieldsCheckActive: false,
        errorsList: []
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false,
        })
    }
    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }
    componentDidMount(){
        this.setState({
            overlayIsOpen: this.props.showModal,
            year: this.props.year,
            month: this.props.month
        })
    }
    componentDidUpdate(){
        if(this.props.year && this.props.month && this.state.year === undefined && this.state.month === undefined && this.props.showModal){
            this.setState({
                year: this.props.year,
                month: this.props.month
            })
        }
    }

    handleUpdate = async () =>{
        await this.setState({loader: true})
        let userId = this.props.user.id;
        let projectId = this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let paymentMethodId = this.props.method.id;

        try{
            const result = await http.post('/api/user/' + userId + '/project/'+ projectId + '/pm/' + paymentMethodId + '/update_date',{
                "exp_year": this.state.year,
                "exp_month": this.state.month
            }, {headers: {authorization: getJwt()}})
            if(result.data.stripe_message || result.data.message){
                toastr.error('Error Code #99017: '+result.data.stripe_message || result.data.message)
                this.setState({loader: false})
            }else if(result.data.data){
                toastr.success('Credit Card date was successfully updated')
                this.props.updatePaymentMethods();
                this.props.handleClose()
                this.setState({loader: false})
            }

        }catch(e){
            this.setState({loader: false})
            toastr.error("Error Code #99018: Credit Card date update was unsuccessful.")
        }
    }

    handleSubmit = async () => {


        // console.log('Evo me 1: ', anyErrorActive, this.state.errorsList)
        // await this.setState({fieldsCheckActive: false})
    }

    render(){

        return(
            <Overlay
                // onClose={this.props.handleClose}
                className={this.state.billingDetailsOpen ? (Classes.OVERLAY_SCROLL_CONTAINER + ' padding-top-400') : Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">
                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={async ()=>{
                                await this.props.handleClose();
                                await this.setState({value: undefined})
                            }}><i className="fas fa-times"></i></p>
                            <h2>Update Credit Card date</h2>
                        </div>
                        {/*{console.log('Errors List: ', this.state.errorsList)}*/}
                        <div className='modal-main'>
                            <div className='display-flex flex-direction-row justify-content-space flex-direction-column-mobile'>
                                <div className='margin-top-20 margin-bottom-10 width-48'>
                                    <InputRegular
                                        id="1"
                                        label1="Month"
                                        label2=""
                                        placeholder="Month can be between 1 - 12"
                                        type='number'
                                        onChange={ (value)=>this.setState({ month: value }) }
                                        value={this.state.month}
                                        required={true}
                                    />

                                </div>
                                <div className='margin-top-20 margin-bottom-10 width-48'>
                                    <InputRegular
                                        id="2"
                                        label1="Year"
                                        label2=""
                                        placeholder="Year can be in format: 2021"
                                        type='number'
                                        onChange={ (value)=>this.setState({ year: value }) }
                                        value={this.state.year}
                                        required={true}
                                    />

                                </div>
                            </div>

                            <div className='flex-end'>
                                <button className='btn-white-border margin-right-20 margin-bottom-30 margin-top-10' onClick={async ()=>{
                                    await this.props.handleClose();
                                    await this.setState({value: undefined})
                                }}>Cancel</button>
                                {this.state.loader ?
                                    <button className='btn-action btn-spinner margin-bottom-30 margin-top-10' disabled={true}>Update  <i className='fa fa-spin fa-spinner'></i></button>
                                    :
                                    <button className='btn-action margin-bottom-30 margin-top-10' onClick={this.handleUpdate}>Update</button>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </Overlay>
        )
    }
}